class MegaMenu extends HTMLElement {
  triggers = this.querySelectorAll('[data-mega-menu-trigger]');
  targets = this.querySelectorAll('[data-mega-menu-target]');

  connectedCallback() {
    this.triggers?.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        this.handleToggle(event);
      });
    });
  }

  handleToggle(event) {
    const { currentTarget } = event;
    const { megaMenuTrigger: contentId } = currentTarget.dataset;

    // Remove active class from all triggers
    if (!currentTarget.classList.contains('level-2')) {
      this.triggers.forEach((trigger) => {
        trigger?.classList.remove('mega-menu__link--active');
      });
    }

    // Add active class to the trigger that was clicked or when the trigger is a back to level 1
    if (currentTarget.classList.contains('level-1')) {
      currentTarget.classList.add('mega-menu__link--active');
    } else {
      this.querySelector(`[data-mega-menu-trigger="${contentId}"]`)?.classList?.add(
        'mega-menu__link--active'
      );
    }

    // Hide all content targets
    this.targets.forEach((target) => {
      target?.classList.add('hidden');
    });

    // Show the target that was clicked
    this.querySelector(`[data-mega-menu-target]#${contentId}`)?.classList?.remove('hidden');
  }
}

customElements.define('mega-menu', MegaMenu);
